'use strict';

var ServiceTypes = require('../constants/ServiceTypes');

function getServiceAccountUrl(serviceAccount) {
  if (serviceAccount.url) {
    return serviceAccount.url;
  }

  switch (serviceAccount.serviceType) {
  case ServiceTypes.FACEBOOK:
    return 'https://facebook.com/' + serviceAccount.externalId;
  case ServiceTypes.TWITTER:
    return 'https://twitter.com/account/redirect_by_id/' + serviceAccount.externalId;
  case ServiceTypes.GOOGLE:
    return 'https://plus.google.com/' + serviceAccount.externalId;
  case ServiceTypes.TUMBLR:
    return 'https://' + serviceAccount.externalId + '.tumblr.com';
  case ServiceTypes.INSTAGRAM:
    return 'https://instagram.com/' + serviceAccount.externalId;
  }
}

module.exports = getServiceAccountUrl;


/** WEBPACK FOOTER **
 ** ./utils/getServiceAccountUrl.js
 **/